import { api } from './client'
import type { InstitutionMe } from '@/types/api'

type InstitutionPaymentGatewayResponse = {
  institution: InstitutionMe
}

export type InstitutionPaymentGatewayInput = {
  default_doey_seller_id: string
  seller_id_totp_code: string
}

export async function updateInstitutionPaymentGateway(
  input: InstitutionPaymentGatewayInput
): Promise<InstitutionMe> {
  const data = await api.put<InstitutionPaymentGatewayResponse>(
    '/api/institution/payment-gateway',
    {
      default_doey_seller_id: input.default_doey_seller_id.trim() || null,
      seller_id_totp_code: input.seller_id_totp_code,
    },
    { requireAuth: true }
  )

  return data.institution
}
